import { Injectable } from '@angular/core';
import {
  DokumentacjaPowiazanaResponseDto,
  GridDataService,
} from '../../gk-kendo';

@Injectable({
  providedIn: 'any',
})
export class FSPRequestDocumentGridDataService extends GridDataService<DokumentacjaPowiazanaResponseDto> {
  constructor() {
    super(undefined, 'GET');
  }
}
